import { shouldPublish } from "src/utils/publishUtils";
import { entertainmentCategoryMatchesRoute } from "src/utils/entertainmentCategory";

const sameIdentity = (a, b) => a != null && b != null && String(a) === String(b);

/**
 * Filters entertainment hub cards by publish window and optional category route slug.
 *
 * @param {import('src/utils/mapEntertainment').EntertainmentCard[]} cards
 * @param {string} [routeCategory] - `params.category` from react-router (EN or FR URL segment)
 * @param {{ livePreviewId?: string|number }} [options]
 * @returns {import('src/utils/mapEntertainment').EntertainmentCard[]}
 */
export function filterEntertainmentCards(cards, routeCategory, options = {}) {
  const { livePreviewId } = options;
  if (!Array.isArray(cards)) return [];

  return cards.filter((card) => {
    const isLiveCard =
      livePreviewId != null &&
      (sameIdentity(card.id, livePreviewId) || sameIdentity(card.name, livePreviewId));
    if (!isLiveCard && !shouldPublish(card)) return false;

    if (routeCategory) {
      return entertainmentCategoryMatchesRoute(routeCategory, card.category);
    }

    return true;
  });
}
